import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class UsuarioApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/usuario/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/usuario/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getUsuarioList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    
    static getInfoPerfil(token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario/perfil",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static getUsuario(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    static getUsuarioBusqueda(cadena, cursoId, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario/busqueda?filtro="+cadena+"&cursoId="+cursoId,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(usuario, token ) {          
      let usuarioEnvio = Object.assign({}, usuario);
		let comando="POST";
		if (usuarioEnvio.id > 0) {
			comando="PUT";			
		} 
		usuarioEnvio=JSON.stringify(usuarioEnvio);
		return $.ajax({
        headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: usuarioEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getUsuarioCombo(tipo, token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario/combo/"+tipo,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    
    static getFotoPerfil(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuario/foto/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
   
    static saveAdjunto(file, token) {  
		return $.ajax({
			url: getLocacion()+"/api/usuario/fperfil",
             headers: {"Authorization": "Bearer " + token.idToken},  
            contentType: false,
            processData: false,            
            type: 'POST',
			data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location ='/login';
				}
			}
		});
	}
    
    static saveAdjuntoProfesor(file, token) {  
		return $.ajax({
			url: getLocacion()+"/api/usuario/fperfilProfesor",
             headers: {"Authorization": "Bearer " + token.idToken},  
            contentType: false,
            processData: false,            
            type: 'POST',
			data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location ='/login';
				}
			}
		});
	}

    
}